/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import icon from 'flarum/common/helpers/icon';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import type User from 'flarum/common/models/User';
import type Mithril from 'mithril';

export interface PostActivityLeaderItemAttrs extends ComponentAttrs {
	user: User;
	position: number;
}

export default class PostActivityLeaderItem extends Component<PostActivityLeaderItemAttrs> {
	oninit(vnode: Mithril.Vnode<PostActivityLeaderItemAttrs, this>) {
		super.oninit(vnode);
	}

	view(): Mithril.Children {
		const { user, position } = this.attrs;

		return (
			<div className="PostActivityLeaderItem">
				<Link href={app.route.user(user)}>
					<span className="ActivityLeaderItem-position">{position.toString().padStart(2, '0')}</span>
					{avatar(user)}
					<div className="ActivityLeaderItem-username">
						{username(user)}

						{user.lastSeenAt() && user.isOnline() && (
							<div className="UserCard-lastSeen online">
								{icon('fas fa-circle')} {app.translator.trans('core.forum.user.online_text')}
							</div>
						)}
					</div>
					<span className="ActivityLeaderItem-count">
						{icon(this.icon)}
						{this.value}
					</span>
				</Link>
			</div>
		);
	}

	get value(): number {
		const { user } = this.attrs;
		return user.recentPostsCount();
	}

	get icon(): string {
		return 'far fa-comment';
	}
}
